import type { FC } from 'react';

import dynamic from 'next/dynamic';

import { TabPanel } from '@mui/lab';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';

import { t } from '@/utils/lang';
import type { EntityComponentProps } from '../../types/EntityComponent.types';
import ReminderScheduleInfo from './Detail/ReminderScheduleInfo';
import TabContainer from './Tabs/Common/TabContainer';

const ReminderSchedule = dynamic(() => import('./Tabs/ReminderSchedule/Task'), {
    ssr: false,
});

const ReminderScheduleEntityContent: FC<EntityComponentProps> = ({ data }) => {
    return (
        <Box>
            <ReminderScheduleInfo data={data} />
            <TabContainer
                defaultTab='reminderSchedule'
                tabPanels={
                    <>
                        <TabPanel value='reminderSchedule'>
                            <ReminderSchedule taskId={data?.id} />
                        </TabPanel>
                    </>
                }
            >
                <Tab label={t('Kế hoạch bảo trì')} value='reminderSchedule' />
            </TabContainer>
        </Box>
    );
};

export default ReminderScheduleEntityContent;
